import React from "react";
import "./account.css";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import Icon1 from "../../assets/images/account_page_sidebar_ic_1.png";
import Icon3 from "../../assets/images/account_page_sidebar_ic_3.png";
import Icon4 from "../../assets/images/account_page_sidebar_ic_4.png";
import Icon5 from "../../assets/images/account_page_sidebar_ic_5.png";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../../Constants";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { updateGrandTotal } from "../../features/cartitemsSlice";
import { FadeLoader } from "react-spinners";
import { useDispatch } from "react-redux";
import Nocouponfound from "../../assets/images/no_coupons_found_img.png";
function Account() {
  const [activeindex, setTabactiveindex] = useState(9);
  const [currentPasswordVisibility, setCurrentPasswordVisibility] =
    useState(false);
  const [newPasswordVisibility, setNewPasswordVisibility] = useState(false);
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] =
    useState(false);

  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.state?.fromCart) {
      setTabactiveindex(9);
    } else {
      setTabactiveindex(1);
    }
  }, [location.state]);

  const user_id = localStorage.getItem("userId");
  const user_name = localStorage.getItem("userName");
  const emailid = localStorage.getItem("email");
  const phone_number = localStorage.getItem("phone_number");

  useEffect(() => {
    if (user_name) {
      setFirstName(user_name);
    }
    if (emailid) {
      setEmail(emailid);
    }
    if (phone_number) {
      setPhonenumber(phone_number);
    }
  }, []);

  const [isEditing, setIsediting] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState([]);
  const [statesid, setStatesid] = useState(null);
  const [citys, setCitys] = useState([]);
  const [cityid, setCityid] = useState(null);
  const [pincode, setPincode] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [errors, setErrors] = useState({});
  const [addressId, setaddressId] = useState(null);
  const [addresslist, setAddresslist] = useState([]);
  const [coupons, setCoupons] = useState([]);

  const validateForm = () => {
    let validationErrors = {};

    // Ensure the fields are treated as strings before using .trim()
    if (!firstName.trim())
      validationErrors.firstName = "First name is required";
    if (!lastName.trim()) validationErrors.lastName = "Last name is required";
    if (!address.trim()) validationErrors.address = "Address is required";
    if (!statesid) validationErrors.state = "Please select a state";
    if (!cityid) validationErrors.city = "Please select a city";

    const pincodeStr = String(pincode).trim(); // Ensure pincode is a string
    if (!pincodeStr) validationErrors.pincode = "Pincode is required";
    else if (pincodeStr.length !== 5)
      validationErrors.pincode = "Pincode must be 5 digits";

    const phoneStr = String(phonenumber).trim(); // Ensure phone number is a string
    if (!phoneStr) validationErrors.phonenumber = "Phone number is required";
    else if (phoneStr.length !== 11 && phoneStr.length !== 10)
      validationErrors.phonenumber = "Phone number must be 10 or 11 digits";

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0; // Return true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        // If isEditing is true, use 'update_address' API and include address_id
        const apiEndpoint = "add_address";

        // If editing, pass the address_id and exclude user_id
        const requestData = isEditing
          ? {
              id: addressId, // Assuming addressId is already available
              first_name: firstName,
              last_name: lastName,
              address: address,
              state_id: statesid,
              city_id: cityid,
              pin_code: pincode,
              email_id: email,
              phone_number: phonenumber,
            }
          : {
              first_name: firstName,
              last_name: lastName,
              address: address,
              state_id: statesid,
              city_id: cityid,
              pin_code: pincode,
              email_id: email,
              phone_number: phonenumber,
              user_id: user_id,
            };

        const response = await axios.post(apiurl + apiEndpoint, requestData);

        if (response.status === 200) {
          toast.success(response.data.message, { autoClose: 2000 });
          setTabactiveindex(2);
          fetchAddressList();
          setFirstName("");
          setLastName("");
          setAddress("");
          setStatesid(null);
          setCityid(null);
          setPincode("");
          setEmail("");
          setPhonenumber("");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleStatechange = (e) => {
    const selectedstateid = e.target.value;
    setStatesid(selectedstateid);
    setCitys([]);
    fetchCity(selectedstateid);
  };

  // Fetch state list on component load
  useEffect(() => {
    const fetchstate = async () => {
      await axios
        .post(apiurl + "state", { country_id: 2 })
        .then((response) => {
          setState(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchstate();
  }, []);

  // Fetch cities based on selected state
  const fetchCity = async (state_id) => {
    await axios
      .post(apiurl + "city", { country_id: 2, state_id: state_id })
      .then((response) => {
        setCitys(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDefaultaddress = async (addressid) => {
    try {
      const response = await axios.post(apiurl + "active_address", {
        address_id: addressid,
        user_id: user_id,
      });

      if (response.status === 200) {
        // Refresh the address list after setting the active address
        setAddresslist([]); // Clear the previous list
        fetchAddressList(); // Re-fetch the updated address list
      }
    } catch (error) {
      console.log(error);
    }
  };

  const navigation = useNavigate();

  const fetchAddressList = () => {
    if (user_id) {
      axios
        .post(apiurl + "address_list", {
          user_id: user_id,
        })
        .then((res) => {
          setAddresslist(res.data.address);
        })
        .catch((error) => {
          console.error("Error fetching address list:", error);
        });
    }
  };

  useEffect(() => {
    if (user_id) {
      axios
        .post(apiurl + "address_list", {
          user_id: user_id,
        })
        .then((res) => {
          setAddresslist(res.data.address);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [user_id]);

  const logoutClick = () => {
    localStorage.removeItem("userName");
    localStorage.removeItem("userId");
    navigation("/");
    window.location.reload();
  };

  const removeAddress = async (addressid) => {
    await axios
      .post(apiurl + "delete_address", {
        address_id: addressid,
      })
      .then((res) => {
        setAddresslist([]);
        fetchAddressList();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [passwordinputfield, setPasswordinputfield] = useState({
    old_password: "",
    password: "",
    password_confirmation: "",
  });

  const [passworderror, setPassworderror] = useState({});

  const handlePasswordchange = (e) => {
    setPasswordinputfield({
      ...passwordinputfield,
      [e.target.name]: e.target.value,
    });
  };

  const handlepassworderror = (inputfield) => {
    let passworderror = {};

    if (inputfield.old_password == "") {
      passworderror.old_password = "old password is required";
    }

    if (inputfield.password == "") {
      passworderror.password = "new password is required";
    } else if (inputfield.password < 6) {
      passworderror.password = "password must be atleast 6 characters long";
    }

    if (inputfield.password_confirmation == "") {
      passworderror.password_confirmation = "confirm password is required";
    } else if (inputfield.password != inputfield.password_confirmation) {
      passworderror.password_confirmation =
        "confirm password and new password does not match";
    }

    return passworderror;
  };

  const handlePasswordsubmit = (e) => {
    e.preventDefault();

    const handleerrorss = handlepassworderror(passwordinputfield);
    setPassworderror(handleerrorss);

    if (Object.keys(handleerrorss).length == 0) {
      const updatepassword = async () => {
        await axios
          .post(apiurl + "change_password", {
            user_id: user_id,
            old_password: passwordinputfield.old_password,
            password: passwordinputfield.password,
            password_confirmation: passwordinputfield.password_confirmation,
          })
          .then((response) => {
            console.log(response);
            if (response.data.success == true) {
              toast.success("password updated successfully", {
                autoClose: 2000,
              });
              localStorage.removeItem("userId");
              localStorage.removeItem("userName");
              navigation("/login");
            }

            if (response.data.success == false) {
              toast.error(response.data.message, { autoClose: 2000 });
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error("Password not updated", { autoClose: 2000 });
          });
      };
      updatepassword();
    }
  };

  const Editaddress = async (addressid) => {
    await axios
      .post(apiurl + "edit_address", {
        address_id: addressid,
      })
      .then((res) => {
        const {
          id,
          first_name,
          last_name,
          address,
          state_id,
          city_id,
          pin_code,
          email_id,
          phone_number,
        } = res.data.address;
        setTabactiveindex(1);
        setaddressId(id);
        setFirstName(first_name);
        setLastName(last_name);
        setAddress(address);
        setStatesid(state_id); // Set the default state
        setCityid(city_id); // Set the default city
        setPincode(pin_code);
        setEmail(email_id);
        setPhonenumber(phone_number);
        setIsediting(true);
        if (state_id) {
          fetchCity(state_id); // Fetch cities based on the state_id
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const { grand_total, shipping_amount } = useSelector(
    (state) => state.cartitems
  );

  const calculategrand_total = async () => {
    try {
      const response = await axios.post(apiurl + "cart_list", {
        user_id: user_id,
      });
      return response.data.total;
    } catch (error) {
      console.error("Error calculating grand total:", error);
      return 0; // Return 0 in case of error
    }
  };

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const Total = await calculategrand_total(); // Await the total
        if (Total) {
          const response = await axios.post(apiurl + "coupons", {
            total_amount: Total, // Pass the grand total
            user_id: user_id,
          });
          setCoupons(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching coupons:", error);
      }
    };
    fetchCoupons();
  }, []);

  const couponsDetails = async (coupon_id) => {
    try {
      const Total = await calculategrand_total();
      const response = await axios.post(apiurl + "coupon_discount_details", {
        coupon_id: coupon_id,
        total_amount: Total,
        shipping_amount: shipping_amount,
      });

      // Assuming the response contains the discount to be applied
      const discountAmount = parseFloat(response.data.data.discount);

      // Subtracting the discount amount from the grand_total
      const updatedGrandTotal = grand_total - discountAmount;

      // Update the grand total in the global state/store
      dispatch(updateGrandTotal(updatedGrandTotal));

      // Store coupon details in localStorage (optional)
      localStorage.setItem("couponDetails", JSON.stringify(response.data.data));
      // Redirect to the checkout screen
      navigation("/checkout-screen");
    } catch (error) {
      console.error("Error applying coupon:", error);
    }
  };

  const [ordertailsLoading, setOrderDetailsLoading] = useState(true);
  const [fetchOrderdetailslist, setFetchorderdetailslist] = useState([]);

  useEffect(() => {
    setOrderDetailsLoading(true);
    const fetchOrderdetails = async () => {
      await axios
        .post(apiurl + "my_orders", {
          user_id: user_id,
        })
        .then((res) => {
          setFetchorderdetailslist(res.data.data);
          setOrderDetailsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchOrderdetails();
  }, []);

  const handleTabChange = (index) => {
    setTabactiveindex(index);

    if (index == 1) {
      const user_id = localStorage.getItem("userId");
      const user_name = localStorage.getItem("userName");
      const emailid = localStorage.getItem("email");
      const phone_number = localStorage.getItem("phone_number");

      if (user_name) {
        setFirstName(user_name);
      }
      if (emailid) {
        setEmail(emailid);
      }
      if (phone_number) {
        setPhonenumber(phone_number);
      }
    }
  };

  return (
    <section className="account_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 left_col">
            <div className="inner-box">
              <div className="user_name">
                <div className="incil_main">
                  {user_name ? (
                    <h5 style={{ textTransform: "uppercase" }}>
                      {" "}
                      {user_name.charAt(0)}{" "}
                    </h5>
                  ) : null}
                </div>
                {user_name ? (
                  <h4 style={{ textTransform: "capitalize" }} className="mb-0">
                    {" "}
                    {user_name}{" "}
                  </h4>
                ) : null}
              </div>
              <div className="sidebar_menu">
                <ul>
                  <li className={`menu_list_parent ${true ? "haschild" : ""}`}>
                    <div className="heading_box">
                      <div className="img_box">
                        <img src={Icon1} alt="icon" />
                      </div>
                      <h6>My Profile</h6>
                    </div>
                    <div className="menu_list_child">
                      <ul>
                        <li
                          onClick={() => handleTabChange(1)}
                          className={`${activeindex === 1 ? "active" : ""}`}
                        >
                          Personal Information
                        </li>
                        <li
                          onClick={() => handleTabChange(2)}
                          className={`${activeindex === 2 ? "active" : ""}`}
                        >
                          Address
                        </li>
                        <li
                          onClick={() => handleTabChange(3)}
                          className={`${activeindex === 3 ? "active" : ""}`}
                        >
                          Change Password
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li
                    className={`menu_list_parent ${
                      activeindex === 9 ? "active" : ""
                    }`}
                    onClick={() => handleTabChange(9)}
                  >
                    <div className="heading_box">
                      <div className="img_box">
                        <img src={Icon3} alt="icon" />
                      </div>
                      <h6>Coupons</h6>
                    </div>
                  </li>

                  <li
                    className={`menu_list_parent ${
                      activeindex === 5 ? "active" : ""
                    }`}
                    onClick={() => handleTabChange(5)}
                  >
                    <div className="heading_box">
                      <div className="img_box">
                        <img src={Icon3} alt="icon" />
                      </div>
                      <h6>Order Details</h6>
                    </div>
                  </li>

                  {/* Notification - no child menu */}
                  <li
                    className={`menu_list_parent ${
                      activeindex === 10 ? "active" : ""
                    }`}
                    onClick={() => handleTabChange(10)}
                  >
                    <div className="heading_box">
                      <div className="img_box">
                        <img src={Icon4} alt="icon" />
                      </div>
                      <h6>Notification</h6>
                    </div>
                  </li>

                  {/* Logout - no child menu */}
                  <li
                    className={`menu_list_parent ${
                      activeindex === 11 ? "active" : ""
                    }`}
                    onClick={() => handleTabChange(11)}
                  >
                    <div className="heading_box" onClick={logoutClick}>
                      <div className="img_box">
                        <img src={Icon5} alt="icon" />
                      </div>
                      <h6>Logout</h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 right_col">
            <div className="inner-box">
              {activeindex === 1 && (
                <div className="personal_information_form_tab">
                  <h5 className="heading_3">Personal Information</h5>
                  <div>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label>First name</label>
                            <br />
                            <input
                              className="form-control"
                              name="first_name"
                              type="text"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  setFirstName(value);
                                }
                              }}
                              value={firstName}
                            />

                            {errors.firstName && (
                              <small className="text-danger">
                                {errors.firstName}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label>Last name</label>
                            <br />
                            <input
                              className="form-control"
                              name="last_name"
                              type="text"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  setLastName(value);
                                }
                              }}
                              value={lastName}
                            />
                            {errors.lastName && (
                              <small className="text-danger">
                                {errors.lastName}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label>Address</label>
                            <br />
                            <textarea
                              className="form-control"
                              name="address"
                              onChange={(e) => setAddress(e.target.value)}
                              value={address}
                            ></textarea>
                            {errors.address && (
                              <small className="text-danger">
                                {errors.address}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label>State</label>
                            <br />
                            <select
                              className="form-control"
                              name="state"
                              onChange={handleStatechange}
                              value={statesid || ""}
                            >
                              <option value="">Select State</option>
                              {state && state.length > 0
                                ? state.map((data, index) => {
                                    return (
                                      <option key={index} value={data.id}>
                                        {data.state_name}
                                      </option>
                                    );
                                  })
                                : null}
                            </select>
                            {errors.state && (
                              <small className="text-danger">
                                {errors.state}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label>City</label>
                            <br />

                            <select
                              name="city"
                              className="form-control"
                              onChange={(e) => setCityid(e.target.value)}
                              value={cityid || ""}
                            >
                              <option value="">Select City</option>
                              {citys.length > 0 ? (
                                citys.map((cityItem, index) => (
                                  <option key={index} value={cityItem.id}>
                                    {cityItem.city_name}
                                  </option>
                                ))
                              ) : (
                                <option value="">No cities available</option>
                              )}
                            </select>
                            {errors.city && (
                              <small className="text-danger">
                                {errors.city}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label>Postal code</label>
                            <br />
                            <input
                              className="form-control"
                              name="pin_code"
                              type="text"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  setPincode(value);
                                }
                              }}
                              value={pincode}
                              maxLength={5}
                            />
                            {errors.pincode && (
                              <small className="text-danger">
                                {errors.pincode}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-8">
                          <div className="mb-3">
                            <label>Email </label>
                            <br />
                            <input
                              className="form-control"
                              name="email_id"
                              type="text"
                              onChange={(e) => setEmail(e.target.value)}
                              value={email}
                            />
                            {errors.email && (
                              <small className="text-danger">
                                {errors.email}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label>Phone Number</label>
                            <br />
                            <input
                              className="form-control"
                              name="phone_number"
                              type="text"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  setPhonenumber(value);
                                }
                              }}
                              value={phonenumber}
                              maxLength={11}
                            />
                            {errors.phonenumber && (
                              <small className="text-danger">
                                {errors.phonenumber}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <button className="btn_1_1" type="submit">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {activeindex === 2 && (
                <div className="address_tab">
                  <h5 className="heading_3">Address</h5>
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-xs-9 grid_col add_new_address_btn">
                      <div className="sub-inner-box">
                        <div
                          onClick={() => handleTabChange(1)}
                          style={{ cursor: "pointer" }}
                        >
                          <span>
                            <FontAwesomeIcon icon={faPlus} />
                          </span>
                        </div>
                        <p>Add Address</p>
                      </div>
                    </div>

                    {addresslist && addresslist.length > 0
                      ? addresslist.map((item, index) => {
                          return (
                            <div
                              className="col-xl-4 col-lg-6 col-md-6 col-sm-8 col-xs-9  grid_col"
                              key={index}
                            >
                              <div className="sub-inner-box">
                                <div className="sub-inner-box-one">
                                  <h6>Deliver to {item.first_name}</h6>
                                  <p>{item.address}</p>
                                </div>
                                <div className="btn_box">
                                  <button onClick={() => Editaddress(item.id)}>
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => removeAddress(item.id)}
                                  >
                                    Remove
                                  </button>
                                  {item.active_status ? (
                                    <button>Default Address</button>
                                  ) : (
                                    <button
                                      onClick={() => setDefaultaddress(item.id)}
                                    >
                                      Set as Default
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : null}

                    {/* <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12  grid_col">
                      <div className="sub-inner-box">
                        <div className="sub-inner-box-one">
                          <h6>Deliver to Raghuraj S</h6>
                          <p>
                            No.7102, Trichy Road, Rukmani Nagar, Ramanathapuram,
                            Coimbatore - 641 054. +91 9412294452
                          </p>
                        </div>
                        <div className="btn_box">
                          <button>Edit</button>
                          <button>Remove</button>
                          <button>Set as Default</button>
                        </div>
                      </div>
                    </div>

                   
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 grid_col">
                      <div className="sub-inner-box">
                        <div className="sub-inner-box-one">
                          <h6>Deliver to Raghuraj S</h6>
                          <p>
                            No.7102, Trichy Road, Rukmani Nagar, Ramanathapuram,
                            Coimbatore - 641 054. +91 9412294452
                          </p>
                        </div>
                        <div className="btn_box">
                          <button>Edit</button>
                          <button>Remove</button>
                          <button>Set as Default</button>
                        </div>
                      </div>
                    </div>

                   
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 grid_col">
                      <div className="sub-inner-box">
                        <div className="sub-inner-box-one">
                          <h6>Deliver to Raghuraj S</h6>
                          <p>
                            No.7102, Trichy Road, Rukmani Nagar, Ramanathapuram,
                            Coimbatore - 641 054. +91 9412294452
                          </p>
                        </div>
                        <div className="btn_box">
                          <button>Edit</button>
                          <button>Remove</button>
                          <button>Set as Default</button>
                        </div>
                      </div>
                    </div>

                 
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 grid_col">
                      <div className="sub-inner-box">
                        <div className="sub-inner-box-one">
                          <h6>Deliver to Raghuraj S</h6>
                          <p>
                            No.7102, Trichy Road, Rukmani Nagar, Ramanathapuram,
                            Coimbatore - 641 054. +91 9412294452
                          </p>
                        </div>
                        <div className="btn_box">
                          <button>Edit</button>
                          <button>Remove</button>
                          <button>Set as Default</button>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              )}

              {activeindex === 3 && (
                <div className="change_password_tab">
                  <h5 className="heading_3">Change Password</h5>
                  <div>
                    <form onSubmit={handlePasswordsubmit}>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                          <div className="mb-3">
                            <label>Current Password</label>
                            <div style={{ position: "relative" }}>
                              <input
                                type={
                                  currentPasswordVisibility
                                    ? "text"
                                    : "password"
                                }
                                name="old_password"
                                onChange={handlePasswordchange}
                                value={passwordinputfield.old_password}
                              />
                              <button
                                type="button"
                                className="toggle_visibility_btn"
                                onClick={() =>
                                  setCurrentPasswordVisibility(
                                    !currentPasswordVisibility
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  icon={
                                    currentPasswordVisibility
                                      ? faEye
                                      : faEyeSlash
                                  }
                                />
                              </button>
                            </div>
                            {passworderror.old_password ? (
                              <p className="err_msg">
                                {passworderror.old_password}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                          <div className="mb-3">
                            <label>New Password</label>
                            <div style={{ position: "relative" }}>
                              <input
                                type={
                                  newPasswordVisibility ? "text" : "password"
                                }
                                name="password"
                                onChange={handlePasswordchange}
                                value={passwordinputfield.password}
                              />
                              <button
                                type="button"
                                className="toggle_visibility_btn"
                                onClick={() =>
                                  setNewPasswordVisibility(
                                    !newPasswordVisibility
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  icon={
                                    newPasswordVisibility ? faEye : faEyeSlash
                                  }
                                />
                              </button>
                            </div>
                            {passworderror.password ? (
                              <p className="err_msg">
                                {passworderror.password}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                          <div className="mb-3">
                            <label>Confirm New Password</label>
                            <div style={{ position: "relative" }}>
                              <input
                                type={
                                  confirmPasswordVisibility
                                    ? "text"
                                    : "password"
                                }
                                name="password_confirmation"
                                onChange={handlePasswordchange}
                                value={passwordinputfield.password_confirmation}
                              />
                              <button
                                type="button"
                                className="toggle_visibility_btn"
                                onClick={() =>
                                  setConfirmPasswordVisibility(
                                    !confirmPasswordVisibility
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  icon={
                                    confirmPasswordVisibility
                                      ? faEye
                                      : faEyeSlash
                                  }
                                />
                              </button>
                            </div>
                            {passworderror.password_confirmation ? (
                              <p className="err_msg">
                                {passworderror.password_confirmation}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="btn_box text-end">
                            {/* <button className="cancel_button mx-2">
                              Cancel
                            </button> */}
                            <button className="btn_1_1">
                              Set new Password
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {activeindex === 5 && (
                <div className="track_your_order_tab">
                  <h5 className="heading_3">Ordered Products</h5>

                  <div className="products_list">
                    <ul>
                      {ordertailsLoading ? (
                        <div
                          className="col-12 d-flex"
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "30px",
                          }}
                        >
                          <FadeLoader size={100} />
                        </div>
                      ) : (
                        <>
                          {fetchOrderdetailslist &&
                          fetchOrderdetailslist.length > 0 ? (
                            fetchOrderdetailslist.map((item, index) => {
                              return (
                                <li className="mt-3">
                                  <div className="table-responsive">
                                    <table className="table w-100">
                                      <thead>
                                        <tr>
                                          <th style={{ width: "33.3%" }}>
                                            Total : RM {item.grand_total}
                                          </th>
                                          <th style={{ width: "23.3%" }}>
                                            {item.product_details.length} items
                                          </th>
                                          <th style={{ width: "43.3%" }}>
                                            Placed on
                                            {new Date(
                                              item.created_at
                                            ).toLocaleString("en-US", {
                                              month: "long",
                                              day: "numeric",
                                              year: "numeric",
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              second: "2-digit",
                                              hour12: true,
                                            })}
                                          </th>
                                        </tr>
                                      </thead>
                                    </table>
                                    <table className="table w-100">
                                      <tbody>
                                        <tr>
                                          <td className="content_box">
                                            <ul>
                                              {item.product_details
                                                .slice(0, 3)
                                                .map((data, ind) => {
                                                  return (
                                                    <li>
                                                      <div className="inner_box_one">
                                                        <div className="img_box">
                                                          <Link
                                                            to={`/product-details/${data.product_id}`}
                                                          >
                                                            <img
                                                              src={
                                                                data
                                                                  .product_image[0]
                                                              }
                                                              alt=""
                                                            />
                                                          </Link>
                                                        </div>
                                                        <div>
                                                          <p>
                                                            <Link
                                                              to={`/product-details/${data.product_id}`}
                                                              style={{
                                                                textDecoration:
                                                                  "none",
                                                                color:
                                                                  "inherit",
                                                              }}
                                                            >
                                                              {" "}
                                                              {
                                                                data.product_name
                                                              }
                                                            </Link>
                                                          </p>
                                                          <p>
                                                            {data.quantity} Qty
                                                          </p>
                                                          <p>
                                                            RM{" "}
                                                            {data.total_price}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </li>
                                                  );
                                                })}
                                            </ul>
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "bottom",
                                            }}
                                            className="btn_box"
                                          >
                                            <Link
                                              to={`/tracing-order-page/${item.id}`}
                                              style={{
                                                textDecoration: "none",
                                              }}
                                              className="btn_6"
                                            >
                                              Order Details
                                            </Link>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            <p className="text-center">
                              No Ordered Products Found
                            </p>
                          )}
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              )}

              {activeindex === 9 && (
                <div className="coupons_tab">
                  <h5 className="heading_3">Coupons</h5>
                  <div className="coupons_box">
                    <div className="row">
                      <>
                        {coupons.length > 0 ? (
                          coupons.map((item, index) => {
                            return (
                              <div
                                className="col-xl-4 col-lg-6 col-md-6 col-sm-12 grid_col"
                                key={index}
                              >
                                <div className="inner-box-one">
                                  <div className="inner-box-two">
                                    <h1>
                                      {item.type === "percentage" ? (
                                        `${parseFloat(item.discount)} %`
                                      ) : (
                                        <>{item.discount}</>
                                      )}
                                    </h1>
                                    <p>valid till : {item.valid_until}</p>

                                    {item.type === "percentage" &&
                                    item.max_dis_amoount > 0 ? (
                                      <p>{`${parseFloat(
                                        item.discount
                                      )}% Discount upto RM ${
                                        item.max_dis_amoount
                                      }`}</p>
                                    ) : null}
                                  </div>
                                  <div className="btn_box">
                                    <span>{item.code}</span>
                                    <button
                                      onClick={() => couponsDetails(item.id)}
                                    >
                                      Collect
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="col-12 nocoupons-found-design">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              <img
                                src={Nocouponfound}
                                style={{ width: "37%" }}
                                alt="img"
                              />
                              <p className="mt-3">No Coupons available</p>
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              )}

              {activeindex === 10 && (
                <div>
                  <h1>Notification</h1>
                </div>
              )}

              {activeindex === 11 && (
                <div>
                  <h1>Log out</h1>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Account;
